module.exports = __webpack_public_path__ + "static/01_area_fincalacelia-7c1d95110d5b8c2d89ae3aa49d5ce9b1.jpg";